import Utils from '../../../../scripts/utils';
import PuzzleData from '../PuzzleData';

export default function generateShuffledFaces(direction, easyMode = false) {
  const faces = [];

  PuzzleData.Cubes.forEach((cube) => {
    for (const face in cube) {
      if (Object.prototype.hasOwnProperty.call(cube, face)) {
        if (face === direction) {
          faces.push(cube[face].face);
        }
      }
    }
  });

  // For debugging, generate the completed puzzle by returning `faces`
  return easyMode ? Utils.shuffleArrayOnce(faces) : Utils.shuffleArray(faces);
}
